import styled from '@emotion/styled';
export const CTAButtonActionsWrapper = styled.div `
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  z-index: 3;
  width: 100%;
  padding: 7%;
  opacity: ${({ isHidden }) => (isHidden ? 0 : 1)};
  transition: opacity 0.3s;
`;
